


























































import {Component, Mixins, Prop, Ref, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive";
import MonitorMixin from "@/design-system/utilities/MonitorMixin"
import anime from "animejs"
import {Portal} from "@linusborg/vue-simple-portal"
import {Location} from "vue-router"

/**
 * @status stable
 * @published 4.4.3
 * @changelog 4.6.0 Switch to simple-portal.
 * @changelog 4.15.0 Add `to` direct link mode.
 * @changelog 6.4.3 Adding `danger` to type.
 */
@Component({components: {SimplePortal: Portal}})
export default class JdsCallout extends Mixins(MonitorMixin) {
    @Ref() popupEl!: HTMLElement
    @Ref() backdropEl!: HTMLElement
    @Ref() triggerEl!: HTMLElement

    state: boolean = false

    @Prop({type: Boolean, default: false}) video!: boolean
    @Prop({type: String, default: 'info'}) type!: 'info'|'warning'|'danger'

    /**
     * Set a location here to make this a direct link callout. Overrides the `video` prop and
     * the `popup` slot, if present.
     */
    @Prop() to!: Location

    keyListener(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            this.close()
        }
    }

    open(e: MouseEvent) {
        if (this.to) return
        document.addEventListener('keyup', this.keyListener)
        this.state = true
    }

    close() {
        document.removeEventListener('keyup', this.keyListener)
        this.state = false
    }

    enter(el: Node, done: () => void) {
        anime.timeline({
            easing: 'easeInOutExpo',
            complete: done,
        }).add({
            targets: this.popupEl,
            scale: [0, 1],
            easing: 'easeOutCubic',
            transformOrigin: this.getOrigin(),
            duration: 400,
            complete: done,
        }).add({
            targets: this.backdropEl,
            opacity: [0, 1],
            duration: 250,
            easing: 'easeOutExpo'
        }, 0)
    }

    leave(el: Node, done: () => void) {
        anime.timeline({
            complete: done,
        }).add({
            targets: this.popupEl,
            opacity: ['100%', '0%'],
            scale: [1, 0.2],
            duration: 300,
            easing: 'easeInCubic',
            complete: done,
            transformOrigin: this.getOrigin()
        }).add({
            targets: this.backdropEl,
            opacity: [1, 0],
            duration: 200,
            easing: 'linear'
        }, 0)
    }

    getOrigin() {
        const x = this.triggerEl.getBoundingClientRect().left - this.popupEl.getBoundingClientRect().left
        const y = this.triggerEl.getBoundingClientRect().top - this.popupEl.getBoundingClientRect().top
        return `${x}px ${y}px`
    }
}
